import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import Asset from 'components/Asset';
import { getHslColor, getPlainName } from './helpers';
import Initials from './Initials';
import EditBtn from './EditBtn';
const Avatar = ({ name, size = 40, avatarImg, className, imgClassName, initialsClassName, Icon, isEditable = false, isRound = false })=>/*#__PURE__*/ _jsxs("div", {
        style: {
            position: 'relative',
            width: size,
            height: size
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cn('avatar', {
                    'avatar--round': isRound
                }, className),
                style: {
                    width: size,
                    height: size,
                    fontSize: size * 0.5
                },
                children: avatarImg ? /*#__PURE__*/ _jsx(Asset, {
                    className: cn('avatar__img', imgClassName),
                    src: avatarImg,
                    alt: getPlainName(name)
                }) : /*#__PURE__*/ _jsx("div", {
                    className: cn('avatar__img avatar__initials_container', imgClassName),
                    style: {
                        backgroundColor: getHslColor(name)
                    },
                    children: /*#__PURE__*/ _jsx(Initials, {
                        name: name,
                        className: initialsClassName
                    })
                })
            }),
            isEditable && /*#__PURE__*/ _jsx(EditBtn, {
                Icon: Icon
            })
        ]
    });
export default Avatar;
